<template>
  <div>
    <div>
      <h1 class="th-title">{{ statusTitle }} Laporan Dinas</h1>
    </div>
    <a-tag :color="displayStatus.color" class="my-2" style="margin-bottom: 24px !important">{{
      displayStatus.txt
    }}</a-tag>
    <a-card v-if="selectedData">
      <h2 class="section-title">Informasi Umum</h2>
      <div class="d-flex flex-column my-2">
        <div class="informasi-row mb-2">
          <div class="w-25 title-send-notif">Perwakilan Dinas</div>
          <div class="value-send-notif">{{ getPemohonName(selectedData) }}</div>
        </div>
        <div class="informasi-row mb-2">
          <div class="w-25 title-send-notif">Nama Kegiatan</div>
          <div class="value-send-notif">{{ selectedData.suratKeluar.namaKegiatan }}</div>
        </div>
        <div class="informasi-row mb-2">
          <div class="w-25 title-send-notif">Tanggal Kegiatan</div>
          <div class="value-send-notif">
            {{ formatWaktuPerjalananRange(selectedData.suratKeluar) }}
          </div>
        </div>
        <div class="informasi-row mb-2" v-if="selectedData.tanggalDalamProses">
          <div class="w-25 title-send-notif">Waktu Dibuat/Unggah</div>
          <div class="value-send-notif">
            {{ formatEventDateTimestamp(selectedData.tanggalDalamProses) }}
            <span v-if="selectedData.tanggalDalamProsesUpdated"
              >(Terakhir diperbarui
              {{ formatEventDateTimestamp(selectedData.tanggalDalamProsesUpdated) }})</span
            >
          </div>
        </div>
        <div class="informasi-row mb-2">
          <div class="w-25 title-send-notif">Tempat Kegiatan</div>
          <div class="value-send-notif">{{ selectedData.suratKeluar.tempatKegiatan }}</div>
        </div>
        <div class="informasi-row mb-2">
          <div class="w-25 title-send-notif">Surat Undangan Acara</div>

          <div class="d-flex align-items-center file-link" v-if="selectedData.suratUndanganAcara">
            <PaperClipOutlined class="mr-2" style="color: rgba(0, 0, 0, 0.45)" />
            <span
              @click="() => handleOpenUrl(selectedData.suratUndanganAcara.pathToFile)"
              class="mr-2 custom-text-anchor"
              >{{ selectedData.suratUndanganAcara.nomorSurat }}</span
            >
            <EyeOutlined
              class="custom-icon-unggah mr-2"
              @click="() => handleOpenPreviewUrl(selectedData.suratUndanganAcara.pathToFile)"
            />
            <ExportOutlined
              class="custom-icon-unggah mr-2"
              @click="() => handleOpenUrl(selectedData.suratUndanganAcara.pathToFile)"
            />
          </div>
          <div class="d-flex align-items-center" v-else>{{ '-' }}</div>
        </div>
        <div class="informasi-row mb-2">
          <div class="w-25 title-send-notif">Surat Tugas</div>

          <div class="d-flex align-items-center file-link">
            <PaperClipOutlined class="mr-2" style="color: rgba(0, 0, 0, 0.45)" />
            <span
              @click="() => handleOpenUrl(selectedData.perwakilanDinas.pdfPath)"
              class="mr-2 custom-text-anchor"
              >{{ selectedData.suratKeluar.nomorSurat }}</span
            >
            <EyeOutlined
              class="custom-icon-unggah mr-2"
              @click="() => handleOpenPreviewUrl(selectedData.perwakilanDinas.pdfPath)"
            />
            <ExportOutlined
              class="custom-icon-unggah mr-2"
              @click="() => handleOpenUrl(selectedData.perwakilanDinas.pdfPath)"
            />
          </div>
        </div>
        <div class="informasi-row mb-2" v-if="selectedData.approvedBySekretaris">
          <div class="w-25 title-send-notif">Sekretaris Peninjau</div>
          <div class="value-send-notif">{{ selectedData.approvedBySekretaris.name }}</div>
        </div>
        <div class="informasi-row mb-2" v-if="selectedData.approvedByBendahara">
          <div class="w-25 title-send-notif">Bendahara Penyetuju</div>
          <div class="value-send-notif">{{ selectedData.approvedByBendahara.name }}</div>
        </div>
        <div class="informasi-row mb-2" v-if="selectedData.approvedByBendahara">
          <div class="w-25 title-send-notif">Nominal Reimburse</div>
          <div class="value-send-notif">Rp.{{ nominalReimburseDisplay }}</div>
        </div>
        <div class="informasi-row mb-2" v-if="selectedData.approvedByBendahara">
          <div class="w-25 title-send-notif">Waktu Pencairan Uang Disetujui</div>
          <div class="value-send-notif">
            {{ formatEventDateTimestamp(selectedData.tanggalDisetujui) }}
          </div>
        </div>
        <div
          class="informasi-row mb-2"
          v-if="selectedData.status === 'Sudah Ditransfer' && selectedData.transferredBySekretaris"
        >
          <div class="w-25 title-send-notif">Sekretaris Pengirim Uang</div>
          <div class="value-send-notif">{{ selectedData.transferredBySekretaris.name }}</div>
        </div>
        <div
          class="informasi-row mb-2"
          v-if="selectedData.status === 'Sudah Ditransfer' && selectedData.tanggalDitransfer"
        >
          <div class="w-25 title-send-notif">Waktu Ditransfer</div>
          <div class="value-send-notif">
            {{ formatEventDateTimestamp(selectedData.tanggalDitransfer) }}
          </div>
        </div>
      </div>
      <a-divider></a-divider>
      <h2 class="section-title">Dokumen Laporan</h2>
      <a-card
        v-if="selectedData.status === 'Revisi' && selectedData.catatanRevisi"
        class="custom-card-revision my-4"
      >
        <div class="d-flex justify-content-between align-items-center mb-2">
          <div>
            <h3 style="color: #444444; font-weight: 700; font-size: 16px">Catatan Revisi</h3>
          </div>
          <div style="color: #444444">Oleh {{ selectedData.approvedBySekretaris.name }}</div>
        </div>
        <div class="custom-card-revision-txt">{{ selectedData.catatanRevisi }}</div>
      </a-card>
      <a-card
        v-if="
          selectedData.status !== 'Revisi' &&
            selectedData.status !== 'Disetujui' &&
            selectedData.catatanRevisi
        "
        class="custom-card-revision-accept my-4"
      >
        <div class="d-flex justify-content-between align-items-center mb-2">
          <div>
            <h3 style="color: #444444; font-weight: 700; font-size: 16px">
              Catatan Revisi <CheckCircleOutlined />
            </h3>
          </div>
          <div style="color: #444444">Oleh {{ selectedData.approvedBySekretaris.name }}</div>
        </div>
        <div class="custom-card-revision-txt">{{ selectedData.catatanRevisi }}</div>
      </a-card>
      <div>
        <div class="informasi-row mb-2">
          <div class="w-25 title-send-notif">Dokumen Lainnya</div>
          <div class="">
            <div v-if="selectedData.dokumenLain && selectedData.dokumenLain.length">
              <div
                v-for="file in selectedData.dokumenLain"
                :key="file.uid"
                class="d-flex align-items-center mb-2 file-link"
              >
                <PaperClipOutlined class="mr-2" style="color: rgba(0, 0, 0, 0.45)" />
                <div class="flex-grow-1">
                  <span class="mr-4 custom-text-anchor-not-clickable">
                    {{ file.displayName || file.name }}
                  </span>
                  <EyeOutlined class="custom-icon-unggah mr-2" @click="() => handlePreview(file)" />
                  <ExportOutlined
                    class="custom-icon-unggah mr-2"
                    @click="() => handleDownload(file)"
                  />
                </div>
              </div>
            </div>
            <div v-else>{{ '-' }}</div>
          </div>
        </div>
        <div class="d-flex flex-wrap mb-2">
          <div class="w-25 title-send-notif">Laporan Dinas</div>
          <div
            v-if="selectedData.laporanDinas && selectedData.laporanDinas.length === 1"
            class="w-100"
          >
            <iframe
              :src="buildFileUrl(selectedData.laporanDinas[0])"
              style="width: 100%; height: 560px; border: none; padding: 12px 8px"
            />
          </div>
          <div v-else>{{ '-' }}</div>
          <a-divider></a-divider>
        </div>
        <div v-if="userRole == 'bendahara' && selectedData.status == 'Terkirim'">
          <h2>Pencairan Uang Dinas</h2>
          <div class="d-flex flex-wrap mb-2">
            <div class="title-send-notif custom-required">Nominal Reimburse</div>
            <div class="nominal-reimburse-field">
              <a-radio-group
                v-model:value="nominalReimburseMode"
                :disabled="selectedData.status !== 'Terkirim'"
                class="nominal-reimburse-options"
                @change="handleNominalReimburseModeChange"
              >
                <a-radio
                  v-for="option in nominalReimburseOptions"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.label }}
                </a-radio>
                <a-radio :value="customNominalReimburseMode">
                  Nominal lainnya
                </a-radio>
              </a-radio-group>

              <a-input
                v-if="isCustomNominalReimburse"
                v-model:value="nominalReimburseDisplay"
                :disabled="selectedData.status !== 'Terkirim'"
                aria-placeholder="0"
                placeholder="0"
                class="custom-input-text-disabled nominal-reimburse-custom-input"
                prefix="Rp. "
                inputmode="numeric"
              />
            </div>
          </div>
          <a-divider></a-divider>
        </div>

        <div
          class="d-flex align-items-center"
          v-if="
            userRole == 'sekretaris' &&
              selectedData.status !== 'Disetujui' &&
              selectedData.status !== 'Terkirim'
          "
        >
          <button
            :disabled="selectedData.status !== 'Dalam Proses'"
            class="button-primary mr-3"
            @click="openModalAcceptReport"
          >
            SETUJUI LAPORAN
          </button>
          <button
            :disabled="selectedData.status !== 'Dalam Proses'"
            class="custom-button-modal-event-no"
            @click="openModalRevisionReport"
          >
            MINTA REVISI
          </button>
        </div>
        <div
          class="d-flex align-items-center"
          v-else-if="userRole == 'sekretaris' && selectedData.status == 'Disetujui'"
        >
          <button class="button-primary" @click="openModalMarkTransferred">
            TANDAI SEBAGAI SUDAH DITRANSFER
          </button>
        </div>
        <div
          class="d-flex align-items-center"
          v-else-if="userRole == 'bendahara' && selectedData.status == 'Terkirim'"
        >
          <button
            :disabled="selectedData.status !== 'Terkirim' || !isNominalReimburseValid"
            class="button-primary mr-3"
            @click="openModalReimburse"
          >
            SETUJUI LAPORAN
          </button>
        </div>
      </div>
    </a-card>
    <a-spin v-else></a-spin>
    <a-modal :footer="null" v-model:visible="modalAcceptReport" @ok="handleSubmitAcceptReport">
      <template #title>
        <h3>Setujui laporan pencairan uang dinas?</h3>
      </template>
      <span
        >Setelah disetujui, laporan akan dikirimkan ke bendahara untuk melanjutkan proses pencairan
        uang dinas.</span
      >

      <div class="d-flex mt-5">
        <button
          @click="closeModalAcceptReport"
          class="flex-grow-1 mx-1 custom-button-modal-event-no"
        >
          KEMBALI
        </button>
        <button
          @click="handleSubmitAcceptReport"
          class="flex-grow-1 mx-1 custom-button-modal-event-yes"
        >
          YA, SERAHKAN
        </button>
      </div>
    </a-modal>
    <a-modal :footer="null" v-model:visible="modalReimburse" @ok="handleSubmitReimburse">
      <template #title>
        <h3>Setujui permohonan pencairan uang dinas sejumlah Rp{{ nominalReimburseDisplay }}?</h3>
      </template>
      <span
        >Pastikan ini laporan serta nominal pencairan uang dinas sudah benar. Setelah menyetuji,
        status pencairan dana berubah menjadi “Disetujui.” Pastikan anda sudah menyelesaikan proses
        reimbusement sebelum menyetujui permohonan pencairan uang dinas.</span
      >

      <div class="d-flex mt-5">
        <button @click="closeModalReimburse" class="flex-grow-1 mx-1 custom-button-modal-event-no">
          KEMBALI
        </button>
        <button
          @click="handleSubmitReimburse"
          class="flex-grow-1 mx-1 custom-button-modal-event-yes"
        >
          SETUJUI
        </button>
      </div>
    </a-modal>
    <a-modal
      :footer="null"
      v-model:visible="modalRevisionReport"
      @ok="handleSubmitRevisionReport"
      @cancel="closeModalRevisionReport"
    >
      <template #title>
        <h3>Minta perwakilan dinas merevisi surat?</h3>
      </template>
      <span
        >Laporan akan dikembalikan ke pemohon untuk direvisi kembali. Mohon masukkan catatan hal
        yang perlu direvisi pada laporan.</span
      >
      <div class="my-3">
        <label class="custom-required" for="">Catatan Revisi</label>
        <a-textarea
          aria-placeholder="Masukkan catatan revisi yang perlu diperbaiki pemohon"
          placeholder="Masukkan catatan revisi yang perlu diperbaiki pemohon"
          :rows="4"
          v-model:value="formState.catatanRevisi"
        ></a-textarea>
      </div>
      <div class="d-flex mt-5">
        <button
          @click="closeModalRevisionReport"
          class="flex-grow-1 mx-1 custom-button-modal-event-no"
        >
          KEMBALI
        </button>
        <button
          @click="handleSubmitRevisionReport"
          class="flex-grow-1 mx-1 custom-button-modal-event-yes"
          :disabled="!formState.catatanRevisi"
        >
          YA, SIMPAN
        </button>
      </div>
    </a-modal>
    <a-modal
      :footer="null"
      v-model:visible="modalMarkTransferred"
      @ok="handleSubmitMarkTransferred"
      @cancel="closeModalMarkTransferred"
    >
      <template #title>
        <h3>Tandai Sebagai Sudah Ditransfer?</h3>
      </template>
      <span
        >Laporan dinas akan ditandai sebagai sudah ditransfer dan status tidak dapat diubah
        kembali.</span
      >
      <div class="d-flex mt-5">
        <button
          @click="closeModalMarkTransferred"
          class="flex-grow-1 mx-1 custom-button-modal-event-no"
        >
          KEMBALI
        </button>
        <button
          @click="handleSubmitMarkTransferred"
          class="flex-grow-1 mx-1 custom-button-modal-event-yes"
        >
          YA, TANDAI
        </button>
      </div>
    </a-modal>
    <a-modal v-model:visible="previewVisible" :footer="null" width="80%">
      <template #title>Preview Dokumen</template>
      <div v-if="previewFile">
        <div v-if="isImage(previewFile)">
          <img
            :src="buildFileUrl(previewFile)"
            alt="Preview"
            style="max-width: 100%; max-height: 70vh; display: block; margin: 0 auto"
          />
        </div>
        <div v-else>
          <iframe
            :src="buildFileUrl(previewFile)"
            style="width: 100%; height: 70vh; border: none"
          />
        </div>
      </div>
    </a-modal>
    <a-modal v-model:visible="modalPreviewUrl" :footer="null" width="80%">
      <template #title>Preview Surat</template>
      <div v-if="selectedSurat">
        <iframe :src="selectedSurat" style="width: 100%; height: 70vh; border: none" />
      </div>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import {
  PaperClipOutlined,
  EyeOutlined,
  ExportOutlined,
  // InboxOutlined,
  // PlusOutlined,
  // EditOutlined,
  // DeleteOutlined,
  CheckCircleOutlined,
} from '@ant-design/icons-vue'
import apiClient, { FILES_URL } from '../../../services/axios/perki'
import { notification } from 'ant-design-vue'
import { useStore } from 'vuex'

export default {
  name: 'CashOutDinasDetail',
  components: {
    PaperClipOutlined,
    EyeOutlined,
    ExportOutlined,
    // InboxOutlined,
    // PlusOutlined,
    // EditOutlined,
    // DeleteOutlined,
    CheckCircleOutlined,
  },
  setup() {
    /** DATAS/STATE */
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    const formState = ref({
      laporanDinas: [],
      dokumenLain: [],
      link: null,
      catatanRevisi: '',
      nominalReimburse: 0,
      deletedDokumenLainIds: [],
    })
    const rulesForm = {
      laporanDinas: [
        {
          required: true,
          message: 'Harap upload laporan dinas!',
          trigger: 'change',
          type: 'array',
        },
      ],
    }
    const editingFileId = ref(null)
    const editedFileName = ref('')
    const previewVisible = ref(false)
    const previewFile = ref(null)
    const selectedSurat = ref('')

    const modalSend = ref(false)
    const modalAcceptReport = ref(false)
    const modalPreviewUrl = ref(false)
    const modalReimburse = ref(false)
    const modalRevisionReport = ref(false)
    const modalMarkTransferred = ref(false)
    const selectedData = ref()
    const customNominalReimburseMode = 'custom'
    const nominalReimbursePresetValues = [350000, 500000, 750000, 1000000]
    const nominalReimburseMode = ref(customNominalReimburseMode)

    /** COMPUTED */
    const userData = computed(() => store.getters['user/user'])
    const userRole = computed(() => userData.value?.role) // misal 'perwakilan', 'sekretaris', 'bendahara'
    const displayStatus = computed(() => {
      if (!selectedData.value) {
        return { txt: '-', color: 'default' }
      }
      return formatStatus(selectedData.value.status, selectedData.value)
    })

    const statusTitle = computed(() => {
      if (!selectedData.value) return 'Unggah'
      return checkStatus(selectedData.value.status)
    })

    /** FUNCTION */
    const formatCurrency = value => {
      if (value === null || value === undefined || value === '') return ''
      const numeric =
        typeof value === 'number' ? value : parseInt(String(value).replace(/\D/g, ''), 10)
      if (!numeric || Number.isNaN(numeric)) return ''
      return numeric.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    }

    const nominalReimburseDisplay = computed({
      get() {
        return formatCurrency(formState.value.nominalReimburse)
      },
      set(val) {
        // Ambil hanya digit
        const onlyDigits = String(val || '').replace(/\D/g, '')
        const numeric = onlyDigits ? parseInt(onlyDigits, 10) : 0
        formState.value.nominalReimburse = numeric
        nominalReimburseMode.value = customNominalReimburseMode
      },
    })
    const nominalReimburseOptions = computed(() => {
      return nominalReimbursePresetValues.map(value => ({
        value,
        label: `Rp ${formatCurrency(value)}`,
      }))
    })
    const isCustomNominalReimburse = computed(
      () => nominalReimburseMode.value === customNominalReimburseMode,
    )
    const isNominalReimburseValid = computed(() => Number(formState.value.nominalReimburse) > 0)
    const syncNominalReimburseMode = value => {
      const numeric = Number(value) || 0
      nominalReimburseMode.value = nominalReimbursePresetValues.includes(numeric)
        ? numeric
        : customNominalReimburseMode
    }
    const handleNominalReimburseModeChange = event => {
      const selectedValue = event?.target?.value
      if (selectedValue === customNominalReimburseMode) {
        nominalReimburseMode.value = customNominalReimburseMode
        return
      }
      formState.value.nominalReimburse = Number(selectedValue) || 0
      nominalReimburseMode.value = Number(selectedValue)
    }
    const formatStatus = (backendStatus, record) => {
      const role = userRole.value // 'perwakilan' | 'sekretaris' | 'bendahara'

      // === POV SEKRETARIS ===
      if (role === 'sekretaris') {
        switch (backendStatus) {
          case 'Dalam Proses':
            return { txt: 'Persetujuan Sekretaris', color: 'orange' }

          case 'Revisi':
            return { txt: 'Menunggu Revisi', color: 'pink' }

          case 'Terkirim':
            return { txt: 'Persetujuan Bendahara', color: 'cyan' }

          case 'Disetujui':
            return { txt: 'Menunggu Transfer', color: 'purple' }
          case 'Sudah Ditransfer':
            return { txt: 'Sudah Ditransfer', color: 'green' }

          default:
            return { txt: backendStatus, color: 'blue' }
        }
      }

      // === POV BENDAHARA ===
      if (role === 'bendahara') {
        switch (backendStatus) {
          case 'Terkirim':
            return { txt: 'Persetujuan Bendahara', color: 'cyan' }
          case 'Dalam Proses':
            return { txt: 'Persetujuan Sekretaris', color: 'orange' }
          case 'Revisi':
            return { txt: 'Menunggu Revisi', color: 'pink' }
          case 'Disetujui':
            return { txt: 'Menunggu Transfer', color: 'purple' }
          case 'Sudah Ditransfer':
            return { txt: 'Sudah Ditransfer', color: 'green' }
          default:
            return { txt: backendStatus, color: 'blue' }
        }
      }
      if (role === 'ketua' || role === 'admin') {
        switch (backendStatus) {
          case 'Terkirim':
            // laporan sudah diforward dari sekretaris, siap disetujui bendahara
            return { txt: 'Persetujuan Bendahara', color: 'cyan' }

          case 'Dalam Proses':
            return { txt: 'Persetujuan Sekretaris', color: 'orange' }
          case 'Disetujui':
            return { txt: 'Menunggu Transfer', color: 'purple' }
          case 'Sudah Ditransfer':
            return { txt: 'Sudah Ditransfer', color: 'green' }

          default:
            return { txt: backendStatus, color: 'blue' }
        }
      }
      // fallback kalau role nggak kebaca / superadmin
      return { txt: backendStatus, color: 'default' }
    }
    const checkStatus = text => {
      const role = userRole.value // 'perwakilan' | 'sekretaris' | 'bendahara'
      if (role === 'ketua' || role === 'admin') {
        return 'Detail'
      } else {
        switch (text) {
          case 'Revisi':
            return 'Revisi'
          // return 'Edit'
          case 'Dalam Proses':
          case 'Terkirim':
          case 'Disetujui':
          case 'Sudah Ditransfer':
          case 'Ditugaskan':
            return 'Detail'

          default:
            return 'Unggah'
        }
      }
    }
    const formatEventDate = date => {
      const startDate = moment(date)
      return startDate.format('DD MMMM YYYY')
    }
    const formatWaktuPerjalananRange = suratKeluar => {
      if (!suratKeluar) return '-'
      const mulai = suratKeluar.waktuPerjalananMulai || suratKeluar.waktuPerjalanan
      if (!mulai) return '-'
      const mulaiDate = moment(mulai).format('DD MMMM YYYY')
      const selesai = suratKeluar.waktuPerjalananSelesai
      if (selesai) {
        const selesaiDate = moment(selesai).format('DD MMMM YYYY')
        if (mulaiDate === selesaiDate) return mulaiDate
        return `${mulaiDate} \u2013 ${selesaiDate}`
      }
      return mulaiDate
    }
    const formatEventDateTimestamp = date => {
      const startDate = moment(date)
      return startDate.format('dddd YYYY-MM-DD HH:mm')
    }
    const openModalSend = () => {
      modalSend.value = true
    }
    const closeModalSend = () => {
      modalSend.value = false
    }
    const buildFileUrl = file => {
      if (!file) return ''
      if (file.url) {
        if (file.url.includes('http')) {
          return file.url
        } else {
          return FILES_URL + '/' + file.url
        }
      }
      if (file.thumbUrl) return file.thumbUrl
      if (file.originFileObj) {
        return URL.createObjectURL(file.originFileObj)
      }
      return ''
    }

    const handlePreview = file => {
      if (!file) return
      previewFile.value = file
      previewVisible.value = true
    }

    const handleDownload = file => {
      const url = buildFileUrl(file)
      if (!url) return
      window.open(url, '_blank')
    }
    const getPemohonName = record => {
      const perwakilan = record?.perwakilanDinas
      return perwakilan?.user?.name || perwakilan?.namaNonPengurus || '-'
    }

    const startEditFileName = file => {
      editingFileId.value = file.uid
      editedFileName.value = file.displayName || file.name
    }

    const saveFileName = file => {
      if (!file) return

      const originalName = file.displayName || file.name || ''
      const dotIndex = originalName.lastIndexOf('.')
      const ext = dotIndex !== -1 ? originalName.slice(dotIndex) : ''

      const cleanedBase = editedFileName.value.replace(/\.[^/.]+$/, '')

      file.displayName = cleanedBase + ext
      editingFileId.value = null
    }

    const removeFile = (file, sect) => {
      // kalau file lama dari DB dan punya id → tandai untuk dihapus
      if (sect === 'dokumenLain' && file.id) {
        formState.value.deletedDokumenLainIds.push(file.id)
      }

      formState.value[sect] = formState.value[sect].filter(f => f.uid !== file.uid)
    }
    const handleChangeLaporan = ({ fileList }) => {
      // hanya simpan 1 file terakhir untuk laporan dinas
      formState.value.laporanDinas = fileList.slice(-1)
    }

    const handleChangeDokumenLain = ({ fileList }) => {
      // formState.value.dokumenLain = fileList
      console.log(fileList)
    }
    const buildFileName = file => {
      // pakai nama yang sudah di-edit, fallback ke nama asli
      return file.displayName || file.name
    }
    const buildFormData = () => {
      const fd = new FormData()

      // 1. Laporan Dinas
      // Kirim hanya jika ada file baru (punya originFileObj).
      if (formState.value.laporanDinas.length) {
        const file = formState.value.laporanDinas[0]
        if (file.originFileObj) {
          const filename = buildFileName(file)
          fd.append('dokumentasiLaporan', file.originFileObj, filename)
        }
        // kalau tidak ada originFileObj → berarti pakai file lama, tidak perlu dikirim lagi
      }

      // 2. Dokumen lain
      // Hanya kirim file baru (punya originFileObj). File lama akan tetap dipakai selama tidak dihapus.
      formState.value.dokumenLain.forEach(file => {
        if (file.originFileObj) {
          const filename = buildFileName(file)
          fd.append('dokumentasiTambahan', file.originFileObj, filename)
        }
      })

      // 3. Daftar ID dokumentasi tambahan yang dihapus
      if (formState.value.deletedDokumenLainIds && formState.value.deletedDokumenLainIds.length) {
        fd.append(
          'deletedDokumenTambahanIds',
          JSON.stringify(formState.value.deletedDokumenLainIds),
        )
      }

      return fd
    }
    const isImage = file => {
      if (!file) return false
      const name = (file.displayName || file.name || '').toLowerCase()
      return name.endsWith('.png') || name.endsWith('.jpg') || name.endsWith('.jpeg')
    }

    const handleOpenModalSend = async () => {
      const formData = buildFormData()
      const isEmpty = formData.entries().next().done

      const hasExistingLaporan =
        formState.value.laporanDinas && formState.value.laporanDinas.length > 0

      // Tidak ada file baru DAN tidak ada laporan dinas sama sekali (baik baru maupun lama)
      if (isEmpty && !hasExistingLaporan) {
        notification.warning({
          message: 'Oops',
          description: 'Harap unggah laporan dinas terlebih dahulu.',
        })
        return
      }

      openModalSend()
    }
    const handleSubmitSend = async () => {
      try {
        const formData = buildFormData()
        const isEmpty = formData.entries().next().done
        const hasExistingLaporan =
          formState.value.laporanDinas && formState.value.laporanDinas.length > 0

        // Tidak ada file baru DAN tidak ada laporan dinas sama sekali (baik baru maupun lama)
        if (isEmpty && !hasExistingLaporan) {
          notification.warning({
            message: 'Oops',
            description: 'Harap unggah laporan dinas terlebih dahulu.',
          })
          return
        }

        const res = await apiClient.post(`/laporan-dinas/${route.params.id}/upload`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        console.log(res.data)
        if (res.data.status === 'success') {
          notification.success({
            message: 'Success',
            description: 'Formulir berhasil dikirim.',
          })
          modalSend.value = false
          router.push('/cash-out')
        }
      } catch (error) {
        console.log(error)
        modalSend.value = false
      }
    }

    const openModalAcceptReport = () => {
      modalAcceptReport.value = true
    }
    const openModalRevisionReport = () => {
      modalRevisionReport.value = true
    }
    const openModalReimburse = () => {
      if (!isNominalReimburseValid.value) {
        notification.warning({
          message: 'Oops',
          description: 'Harap masukkan nominal reimburse terlebih dahulu.',
        })
        return
      }
      modalReimburse.value = true
    }
    const closeModalReimburse = () => {
      modalReimburse.value = false
    }
    const closeModalAcceptReport = () => {
      modalAcceptReport.value = false
    }
    const closeModalRevisionReport = () => {
      modalRevisionReport.value = false
      formState.value.catatanRevisi = ''
    }
    const openModalMarkTransferred = () => {
      modalMarkTransferred.value = true
    }
    const closeModalMarkTransferred = () => {
      modalMarkTransferred.value = false
    }

    const handleSubmitAcceptReport = async () => {
      const { data } = await apiClient.post(`/laporan-dinas/${route.params.id}/approve`)
      console.log(data, '<<')
      if (data.status === 'success') {
        notification.success({
          message: 'Success',
          description: 'Laporan berhasil disetujui.',
        })
        modalAcceptReport.value = false
        router.push('/cash-out')
      } else {
      }
    }
    const handleSubmitRevisionReport = async () => {
      const { data } = await apiClient.post(`/laporan-dinas/${route.params.id}/revise`, {
        catatanRevisi: formState.value.catatanRevisi,
      })
      if (data.status === 'success') {
        notification.success({
          message: 'Success',
          description: 'Laporan berhasil ditandai sebagai revisi.',
        })
        modalRevisionReport.value = false
        router.push('/cash-out')
      } else {
        notification.warning({
          message: 'Error',
          description: 'Laporan gagal direvisi. Silahkan coba kembali lagi nanti',
        })
        modalRevisionReport.value = false
      }
    }
    const handleSubmitReimburse = async () => {
      if (!isNominalReimburseValid.value) {
        notification.warning({
          message: 'Oops',
          description: 'Harap masukkan nominal reimburse terlebih dahulu.',
        })
        return
      }

      try {
        const { data } = await apiClient.post(
          `/laporan-dinas/${route.params.id}/approve-reimburse`,
          { nominalReimburse: formState.value.nominalReimburse },
        )
        console.log(data, '<<')
        if (data.status === 'success') {
          notification.success({
            message: 'Success',
            description: 'Pencairan uang dinas berhasil disetujui.',
          })
          modalReimburse.value = false
          router.push('/cash-out')
        } else {
        }
      } catch (error) {}
    }
    const handleSubmitMarkTransferred = async () => {
      try {
        const { data } = await apiClient.post(`/laporan-dinas/${route.params.id}/mark-transferred`)
        if (data.status === 'success') {
          notification.success({
            message: 'Success',
            description: 'Status laporan berhasil diubah.',
          })
          modalMarkTransferred.value = false
          router.push('/cash-out')
        } else {
          notification.warning({
            message: 'Error',
            description: 'Gagal menandai laporan sebagai sudah ditransfer.',
          })
        }
      } catch (error) {
        notification.warning({
          message: 'Error',
          description: 'Gagal menandai laporan sebagai sudah ditransfer.',
        })
      }
    }
    const getDataCurrent = async () => {
      const {
        data: { data },
      } = await apiClient.get(`/laporan-dinas/${route.params.id}`)

      selectedData.value = data

      const dokumentasiLaporan = data.dokumentasiLaporan
        ? [
            {
              uid: `laporan-${data.id}`,
              id: null, // kalau di DB nggak ada ID khusus
              url: data.dokumentasiLaporan,
              name: data.dokumentasiLaporan.split('/').pop(),
              displayName: data.dokumentasiLaporanName || data.dokumentasiLaporan.split('/').pop(),
              status: 'done',
              isExisting: true, // penanda file lama
            },
          ]
        : []

      const dokumentasiTambahan = (data.dokumentasiTambahan || []).map(e => ({
        uid: e.id, // penting, buat key & filter
        id: e.id, // id row di DB
        url: e.fileUrl,
        name: e.fileUrl.split('/').pop(),
        status: 'done',
        isExisting: true, // penanda file dari backend
      }))

      formState.value.laporanDinas = dokumentasiLaporan
      formState.value.dokumenLain = dokumentasiTambahan
      formState.value.nominalReimburse = data.nominalReimburse
      syncNominalReimburseMode(data.nominalReimburse)
      selectedData.value.laporanDinas = dokumentasiLaporan
      selectedData.value.dokumenLain = dokumentasiTambahan

      console.log(dokumentasiLaporan, '\n', dokumentasiTambahan)
    }
    const handleOpenUrl = async path => {
      const fullpath = `${FILES_URL}/${path}`
      window.open(fullpath, '_blank')
    }
    const handleOpenPreviewUrl = async path => {
      const fullpath = `${FILES_URL}/${path}`
      selectedSurat.value = fullpath
      modalPreviewUrl.value = true
      // window.open(fullpath, '_blank')
    }
    /** CYCLE */
    onMounted(async () => {
      await getDataCurrent()
    })

    return {
      /** DATA */
      selectedData,
      formState,
      rulesForm,
      editingFileId,
      editedFileName,
      previewVisible,
      previewFile,
      modalSend,
      modalAcceptReport,
      modalRevisionReport,
      modalReimburse,
      modalMarkTransferred,
      displayStatus,
      statusTitle,
      userRole,
      selectedSurat,
      modalPreviewUrl,
      customNominalReimburseMode,
      nominalReimburseMode,
      nominalReimburseDisplay,
      nominalReimburseOptions,
      isCustomNominalReimburse,
      isNominalReimburseValid,

      /** FUNCTION */
      formatStatus,
      formatCurrency,

      checkStatus,
      formatEventDate,
      formatWaktuPerjalananRange,
      formatEventDateTimestamp,
      handlePreview,
      handleDownload,
      getPemohonName,
      startEditFileName,
      saveFileName,
      removeFile,
      handleChangeLaporan,
      handleChangeDokumenLain,
      buildFileUrl,
      isImage,
      handleSubmitSend,

      handleOpenModalSend,
      openModalSend,
      closeModalSend,
      handleOpenPreviewUrl,
      handleOpenUrl,
      handleNominalReimburseModeChange,

      openModalAcceptReport,
      openModalRevisionReport,
      openModalReimburse,
      closeModalReimburse,
      closeModalAcceptReport,
      closeModalRevisionReport,
      handleSubmitAcceptReport,
      handleSubmitRevisionReport,
      handleSubmitReimburse,
      openModalMarkTransferred,
      closeModalMarkTransferred,
      handleSubmitMarkTransferred,
    }
  },
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
.custom-icon-unggah {
  color: $primary !important;
}
.custom-card-revision {
  background-color: #efefff;
}
.custom-card-revision-accept {
  background-color: #cdf3ce;
}
.custom-card-revision-txt {
  background-color: $white;
  padding: 8px;
}
.custom-required {
  color: $black;
  font-size: 14px;
  font-weight: 500;
  position: relative;
  &::before {
    display: inline-block;
    margin-right: 4px;
    color: #f5222e;
    font-size: 14px;
    font-family: SimSun, sans-serif;
    line-height: 1;
    content: '*';
    position: absolute;
    right: -10px;
    margin: 0 !important;
  }
  // &::after{
  //   display: inline-block;
  // margin-right: 4px;
  // color: #f5222e;
  // font-size: 14px;
  // font-family: SimSun, sans-serif;
  // line-height: 1;
  // content: '*';
  // }
}
.custom-input-text-disabled {
  background-color: $white;
  color: $black;
  :deep(.ant-input-disabled) {
    background-color: $white;
    color: $black;
  }
}
.nominal-reimburse-field {
  width: 100%;
}
.nominal-reimburse-options {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin-bottom: 12px;
}
.nominal-reimburse-options :deep(.ant-radio-wrapper) {
  margin-right: 0;
}
.nominal-reimburse-options :deep(.ant-radio-checked .ant-radio-inner) {
  border-color: $primary !important;
}
.nominal-reimburse-options :deep(.ant-radio-checked .ant-radio-inner::after) {
  background-color: $primary !important;
}
.nominal-reimburse-options :deep(.ant-radio-wrapper:hover .ant-radio .ant-radio-inner),
.nominal-reimburse-options :deep(.ant-radio:hover .ant-radio-inner) {
  border-color: $primary !important;
}
.nominal-reimburse-options :deep(.ant-radio-input:focus + .ant-radio-inner) {
  box-shadow: 0 0 0 3px rgba(225, 15, 40, 0.2);
}
.nominal-reimburse-custom-input {
  max-width: 360px;
}
.custom-text-anchor {
  cursor: pointer;
  color: #321e8d;
  transition: all 0.2s ease-in-out;
  &:hover {
    text-decoration: underline;
    color: $primary;
  }
}

.custom-text-anchor-not-clickable {
  color: #321e8d;
  transition: all 0.2s ease-in-out;
  &:hover {
    color: $primary;
  }
}

.th-title {
  font-weight: 700;
  font-size: 24px;
}

.section-title {
  font-weight: 700;
  font-size: 20px;
  color: #282828;
  margin-bottom: 16px;
}

.informasi-row {
  display: flex;
  margin-bottom: 12px;

  @media (max-width: 576px) {
    flex-direction: column;
  }
}

.title-send-notif {
  @media (max-width: 576px) {
    width: 100% !important;
  }
}

:deep(.ant-card-body) {
  @media (max-width: 576px) {
    padding: 12px !important;
  }
}

.file-link {
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;

  @media (max-width: 768px) {
    white-space: normal;
    flex-wrap: wrap;
    word-break: break-word;
  }

  .file-link-name {
    flex: 1;
    word-break: break-word;
  }

  &:hover {
    text-decoration: underline;
  }
}

::v-deep(.ant-tag) {
  font-weight: 700;
  border-radius: 50px;
}
</style>
